import { useEffect } from 'react'

import { useAuthInfo } from '../../api/auth'
import UserArea from './UserArea'
import { useSession } from '../../session'
import * as style from './SiteHeader.style'


interface Props {
  profilePath: string
  userSettingsPath: string
  logoutPath: string
}

const SiteHeader = ({ profilePath, userSettingsPath, logoutPath }: Props): JSX.Element => {
  const { handleLogout } = useSession()
  const [authInfoStatus, loadAuthInfo] = useAuthInfo()

  useEffect(() => {
    void loadAuthInfo()
  }, [])

  return (
    <header className={style.header}>
      {authInfoStatus.state === 'success' && authInfoStatus.data?.testAuthenticationEnabled && (
        <span className={style.testServerBadge}>TEST SERVER</span>
      )}
      <UserArea
        profilePath={profilePath}
        userSettingsPath={userSettingsPath}
        logoutPath={logoutPath}
        onLogout={handleLogout}
      />
    </header>
  )
}

export default SiteHeader
